import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Search } from '@saucelabs/ds-inputs';

import selectors from '../selectors';
import actions from '../actions';

const UploadToSdCardFilesSearch: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const { searchTerm } = useSelector(selectors.uploadToSdCardSelector);

  return (
    <div className="max-w-39.75 flex-1">
      <Search
        onChange={(search) => dispatch(actions.searchByFileName(search))}
        placeholder="Search by name"
        value={searchTerm}
      />
    </div>
  );
};

UploadToSdCardFilesSearch.displayName = 'UploadToSdCardFilesSearch';

export default UploadToSdCardFilesSearch;
